// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__28r6X","dragIcon":"SortableItem_dragIcon__hp8dS","disabled":"SortableItem_disabled__gHD1u"};